import { FURNITURE_CONFIG } from '~/components/ThreeDModel/furnitureConfig'

export interface ColumnDividerDimensionsInput {
  columnHeight: number
  columnDepth: number
  plintHeight: number
}

export interface ColumnDividerDimensions {
  width: number
  height: number
}

export function computeColumnDividerDimensions(
  input: ColumnDividerDimensionsInput
): ColumnDividerDimensions {
  const { panelThickness } = FURNITURE_CONFIG
  const { columnHeight, columnDepth, plintHeight } = input

  return {
    width: columnDepth - 2 * panelThickness,
    height: columnHeight - plintHeight - panelThickness,
  }
}
